<template>
  <b-modal
    :id="modalId"
    ref="modalSuccessDelete"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    body-class="!p-0"
    dialog-class="modal-dialog-centered !max-w-[440px] !w-full mx-auto"
    content-class="!rounded-[24px] !border-0 overflow-hidden bg-white"
  >
    <div class="bg-white rounded-[24px] p-8 w-full mx-auto flex flex-col items-center">
      <!-- Icon -->
      <div class="flex items-center justify-center mb-6">
        <img
          src="https://storage.googleapis.com/komerce/assets/icons/success.svg"
          alt="Success"
          width="100"
          height="100"
          class="w-[100px] h-[100px]"
        >
      </div>

      <!-- Text -->
      <h4 class="text-center font-semibold text-[20px] text-[#1f1f1f] mb-2 mt-0">
        Konten Berhasil Dihapus
      </h4>
      <p class="text-center text-[#8c8c8c] text-sm leading-[1.5] mb-8 mt-0">
        Konten yang kamu pilih telah berhasil dihapus dan tidak dapat dipulihkan.
      </p>

      <!-- Actions -->
      <button
        type="button"
        class="w-full h-[48px] rounded-[16px] font-medium text-sm text-white bg-[#ff6a13] hover:bg-[#ff7d32] border-0 m-0 transition-all duration-200 outline-none focus:outline-none flex items-center justify-center cursor-pointer text-nowrap"
        @click="handleClose"
      >
        Oke
      </button>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    modalId: {
      type: String,
      required: true,
    },
  },
  methods: {
    handleClose() {
      this.$bvModal.hide(this.modalId)
      this.$emit('close')
    },
  },
}
</script>
